import Axios from "axios"

const ViaCepRequest = {
  cepData(cep) {
    return Axios.get(`https://viacep.com.br/ws/${cep}/json/`)
  }
}

export default ViaCepRequest